import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponseWithPagination, GetGoalsSchema, GoalsResponseDataSchema } from "schema"
import { z } from "zod"

type Query = z.input<typeof GetGoalsSchema>
type Response = DataResponseWithPagination<z.infer<typeof GoalsResponseDataSchema>>

type Props = {
  query?: Query
  onSuccess?: (data: Response) => void
  enabled?: boolean
}

export const getGoalsQueryKey = (query: Query = {}) => ["goals", query]

export const goalsQuery = ({ query, onSuccess, enabled = true }: Props) => {
  return queryOptions({
    queryKey: getGoalsQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/goals`, { params: query })
      onSuccess?.(data)
      return data.data
    },
    enabled,
  })
}
